module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (240).760711aa.jpg";